<template>
  <div class="link-shortener">
    <div class="form-container">
      <!-- Заголовок -->
      <div class="header">
        <h1 class="title">Создать короткую ссылку</h1>
        <p class="subtitle">Превратите длинные URL в короткие и удобные ссылки</p>
      </div>

      <!-- Форма -->
      <form @submit.prevent="handleSubmit" class="form">
        <!-- URL поле -->
        <div class="form-group">
          <label for="url" class="label">
            <span class="label-text">URL для сокращения</span>
            <span class="required">*</span>
          </label>
          <div class="input-wrapper">
            <div class="input-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
              </svg>
            </div>
            <input
              id="url"
              v-model="formData.url"
              type="url"
              class="input"
              :class="{ 'input-error': errors.url }"
              placeholder="https://example.com/very-long-url"
              required
            />
          </div>
          <div v-if="errors.url" class="error-message">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="15" y1="9" x2="9" y2="15"></line>
              <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>
            {{ errors.url }}
          </div>
        </div>

                 <!-- Кастомный адрес -->
         <div class="form-group">
           <label for="customAddress" class="label">
             <span class="label-text">Короткий адрес</span>
           </label>
          <div class="input-wrapper">
            <div class="input-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
              </svg>
            </div>
            <div class="domain-prefix">ncht.bz/</div>
            <input
              id="customAddress"
              v-model="formData.customAddress"
              type="text"
              class="input custom-address-input"
              :class="{ 'input-error': errors.customAddress }"
              placeholder="my-link"
              maxlength="64"
            />
          </div>
          <div v-if="errors.customAddress" class="error-message">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="15" y1="9" x2="9" y2="15"></line>
              <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>
            {{ errors.customAddress }}
          </div>
                     <div class="help-text">От 2 до 64 символов, только буквы, цифры и дефисы (опционально)</div>
        </div>

        <!-- Дополнительные настройки -->
        <div class="advanced-settings">
          <button 
            type="button" 
            class="settings-toggle"
            @click="showAdvanced = !showAdvanced"
          >
            <span>Дополнительные настройки</span>
            <svg 
              width="20" 
              height="20" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              stroke-width="2"
              :class="{ 'rotate': showAdvanced }"
            >
              <polyline points="6,9 12,15 18,9"></polyline>
            </svg>
          </button>

          <div v-if="showAdvanced" class="advanced-content">
            <!-- Пароль -->
            <div class="form-group">
              <label for="password" class="label">
                <span class="label-text">Пароль защиты</span>
              </label>
              <div class="input-wrapper">
                <div class="input-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                    <circle cx="12" cy="16" r="1"></circle>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </svg>
                </div>
                <input
                  id="password"
                  v-model="formData.password"
                  type="password"
                  class="input"
                  placeholder="Оставьте пустым для публичной ссылки"
                />
              </div>
              <div class="help-text">Ссылка будет доступна только с паролем</div>
            </div>

                         <!-- Время истечения -->
             <div class="form-group">
               <label class="label">
                 <span class="label-text">Время жизни ссылки</span>
               </label>
               <div class="expiration-wrapper">
                 <div class="input-wrapper">
                   <div class="input-icon">
                     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                       <circle cx="12" cy="12" r="10"></circle>
                       <polyline points="12,6 12,12 16,14"></polyline>
                     </svg>
                   </div>
                   <input
                     v-model="formData.expirationValue"
                     type="number"
                     class="input"
                     :class="{ 'input-error': errors.expiration }"
                     min="1"
                     placeholder="Без ограничений"
                   />
                 </div>
                                   <select 
                    v-model="formData.expirationUnit" 
                    class="select"
                    :disabled="formData.expirationValue === null"
                  >
                    <option value="minutes">минут</option>
                    <option value="hours">часов</option>
                    <option value="days">дней</option>
                  </select>
                 <button 
                   type="button"
                   class="clear-button"
                   @click="formData.expirationValue = null"
                   v-if="formData.expirationValue !== null"
                 >
                   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                     <circle cx="12" cy="12" r="10"></circle>
                     <line x1="15" y1="9" x2="9" y2="15"></line>
                     <line x1="9" y1="9" x2="15" y2="15"></line>
                   </svg>
                 </button>
               </div>
               <div v-if="errors.expiration" class="error-message">
                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                   <circle cx="12" cy="12" r="10"></circle>
                   <line x1="15" y1="9" x2="9" y2="15"></line>
                   <line x1="9" y1="9" x2="15" y2="15"></line>
                 </svg>
                 {{ errors.expiration }}
               </div>
               <div class="help-text">
                 <span v-if="formData.expirationValue === null">Ссылка будет активна бессрочно</span>
                 <span v-else>Ссылка автоматически истечет через указанное время</span>
               </div>
             </div>

            <!-- Описание -->
            <div class="form-group">
              <label for="description" class="label">
                <span class="label-text">Описание</span>
              </label>
              <textarea
                id="description"
                v-model="formData.description"
                class="textarea"
                rows="3"
                placeholder="Краткое описание ссылки (опционально)"
                maxlength="500"
              ></textarea>
              <div class="help-text">
                <span>{{ formData.description.length }}/500 символов</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Кнопка отправки -->
        <div class="submit-section">
          <button
            type="submit"
            class="submit-button"
            :class="{ 'loading': isSubmitting }"
            :disabled="!isFormValid || isSubmitting"
          >
            <span v-if="!isSubmitting" class="button-content">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
              </svg>
              Создать короткую ссылку
            </span>
            <span v-else class="button-content">
              <div class="spinner"></div>
              Создание...
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, reactive, watch } from 'vue'

// Props
// eslint-disable-next-line no-undef
const props = defineProps({
  initialUrl: {
    type: String,
    default: ''
  }
})

// Emits
// eslint-disable-next-line no-undef
const emit = defineEmits(['link-created', 'error'])

// Состояние формы
const isSubmitting = ref(false)
const showAdvanced = ref(false)

const formData = reactive({
  url: props.initialUrl,
  customAddress: '',
  password: '',
  expirationValue: null,
  expirationUnit: 'days',
  description: ''
})

const errors = reactive({
  url: '',
  customAddress: '',
  expiration: ''
})

   // Валидация формы
  const isFormValid = computed(() => {
    if (!formData.url) return false
    
    if (formData.customAddress && (formData.customAddress.length < 2 || formData.customAddress.length > 64)) return false
    if (formData.customAddress && !/^[a-zA-Z0-9-]+$/.test(formData.customAddress)) return false
    
    if (formData.expirationValue !== null && formData.expirationValue < 1) return false
    
    return true
  })

// Валидация кастомного адреса
const validateCustomAddress = (address) => {
  if (address.length < 2) return 'Адрес должен содержать минимум 2 символа'
  if (address.length > 64) return 'Адрес не может быть длиннее 64 символов'
  if (!/^[a-zA-Z0-9-]+$/.test(address)) return 'Адрес может содержать только буквы, цифры и дефисы'
  return ''
}

// Обработка изменений
const handleCustomAddressChange = () => {
  errors.customAddress = validateCustomAddress(formData.customAddress)
}

// Обработка отправки формы
const handleSubmit = async () => {
  // Сброс ошибок
  errors.url = ''
  errors.customAddress = ''
  errors.expiration = ''
  
  // Валидация
  if (!formData.url) {
    errors.url = 'URL обязателен'
    return
  }
  
  if (formData.customAddress) {
    const customError = validateCustomAddress(formData.customAddress)
    if (customError) {
      errors.customAddress = customError
      return
    }
  }
  
  if (formData.expirationValue !== null && formData.expirationValue < 1) {
    errors.expiration = 'Время жизни должно быть больше 0'
    return
  }
  
  isSubmitting.value = true
  
  try {
    // Формируем данные для отправки
    const submitData = {
      target: formData.url,
      description: formData.description || '',
      password: formData.password || '',
      customurl: formData.customAddress || '',
      reuse: false,
      domain: 'ncht.bz'
    }
    
    // Добавляем expire_in только если указано время истечения
    if (formData.expirationValue !== null) {
      submitData.expire_in = `${formData.expirationValue} ${formData.expirationUnit}`
    }
    
         // Отправляем API запрос через прокси
     const response = await fetch('/api/shorten-link', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(submitData)
     })
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    
    const result = await response.json()
    console.log('Короткая ссылка создана:', result)
    
    // Эмитим событие с результатом
    emit('link-created', result)
    
    // Сброс формы после успешного создания
    resetForm()
    
  } catch (error) {
    console.error('Ошибка при создании короткой ссылки:', error)
    // Эмитим событие с ошибкой
    emit('error', error.message || 'Ошибка при создании короткой ссылки')
  } finally {
    isSubmitting.value = false
  }
}

   // Сброс формы
  const resetForm = () => {
    formData.url = ''
    formData.customAddress = ''
    formData.password = ''
    formData.expirationValue = null
    formData.expirationUnit = 'days'
    formData.description = ''
    errors.url = ''
    errors.customAddress = ''
    errors.expiration = ''
  }

// Наблюдаем за изменениями кастомного адреса
watch(() => formData.customAddress, handleCustomAddressChange)

// Наблюдаем за изменениями initialUrl
watch(() => props.initialUrl, (newUrl) => {
  formData.url = newUrl
})
</script>

<style scoped>
  .link-shortener {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }

.form-container {
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  padding: 3rem;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

.header {
  text-align: center;
  margin-bottom: 2.5rem;
}

.title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 0.5rem 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.subtitle {
  font-size: 1.1rem;
  color: #718096;
  margin: 0;
  font-weight: 400;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.label {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-weight: 600;
  color: #2d3748;
  font-size: 0.95rem;
}

.label-text {
  color: #4a5568;
}

.required {
  color: #e53e3e;
  font-weight: 700;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background: #f7fafc;
  border: 2px solid transparent;
  border-radius: 12px;
  transition: all 0.2s ease;
}

.input-wrapper:focus-within {
  background: white;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.input-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  color: #a0aec0;
  flex-shrink: 0;
}

.input {
  flex: 1;
  border: none;
  background: transparent;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  color: #2d3748;
  outline: none;
  border-radius: 12px;
}

.input::placeholder {
  color: #a0aec0;
}

.input-error {
  color: #e53e3e;
}

.domain-prefix {
  background: #edf2f7;
  color: #4a5568;
  padding: 0.75rem 0.5rem;
  font-size: 0.9rem;
  font-weight: 500;
  border-radius: 8px 0 0 8px;
  border-right: 1px solid #e2e8f0;
}

.custom-address-input {
  border-radius: 0 8px 8px 0;
}

.error-message {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #e53e3e;
  font-size: 0.875rem;
  font-weight: 500;
}

.help-text {
  color: #718096;
  font-size: 0.875rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.advanced-settings {
  border-top: 1px solid #e2e8f0;
  padding-top: 1.5rem;
  margin-top: 1rem;
}

.settings-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: none;
  border: none;
  padding: 0.75rem 0;
  color: #4a5568;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: color 0.2s ease;
}

.settings-toggle:hover {
  color: #667eea;
}

.settings-toggle svg {
  transition: transform 0.2s ease;
}

.settings-toggle svg.rotate {
  transform: rotate(180deg);
}

.advanced-content {
  margin-top: 1rem;
  padding: 1.5rem;
  background: #f7fafc;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

 .expiration-wrapper {
   display: flex;
   gap: 0.75rem;
   align-items: stretch;
 }
 
 .expiration-wrapper .input-wrapper {
   flex: 1;
   min-width: 0;
 }
 
 .expiration-wrapper .input {
   min-width: 0;
   width: 100%;
 }

 .select {
   background: #f7fafc;
   border: 2px solid transparent;
   border-radius: 12px;
   padding: 0.75rem 1rem;
   font-size: 1rem;
   color: #2d3748;
   outline: none;
   cursor: pointer;
   transition: all 0.2s ease;
   min-width: 120px;
 }
 
 .select:focus {
   background: white;
   border-color: #667eea;
   box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
 }
 
 .select:disabled {
   opacity: 0.5;
   cursor: not-allowed;
   background: #e2e8f0;
 }
 
 .clear-button {
   background: #fed7d7;
   border: 2px solid transparent;
   border-radius: 12px;
   padding: 0.75rem;
   color: #e53e3e;
   outline: none;
   cursor: pointer;
   transition: all 0.2s ease;
   display: flex;
   align-items: center;
   justify-content: center;
   min-width: 48px;
 }
 
 .clear-button:hover {
   background: #feb2b2;
   border-color: #e53e3e;
 }

.textarea {
  background: #f7fafc;
  border: 2px solid transparent;
  border-radius: 12px;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  color: #2d3748;
  outline: none;
  resize: vertical;
  min-height: 80px;
  transition: all 0.2s ease;
  font-family: inherit;
}

.textarea:focus {
  background: white;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.textarea::placeholder {
  color: #a0aec0;
}

.submit-section {
  margin-top: 1rem;
}

.submit-button {
  width: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
}

.submit-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.3);
}

.submit-button:active:not(:disabled) {
  transform: translateY(0);
}

.submit-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.button-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Адаптивность */
@media (max-width: 768px) {
  .link-shortener {
    padding: 1rem;
  }
  
  .form-container {
    padding: 2rem;
    border-radius: 16px;
  }
  
  .title {
    font-size: 2rem;
  }
  
  .expiration-wrapper {
    flex-direction: column;
  }
  
  .select {
    min-width: auto;
  }
}

@media (max-width: 480px) {
  .form-container {
    padding: 1.5rem;
  }
  
  .title {
    font-size: 1.75rem;
  }
  
  .subtitle {
    font-size: 1rem;
  }
}
</style>
  